// extracted by mini-css-extract-plugin
export var equalColumn = "_gb-0";